<template>
  <table class="paiements">
    <tr>
      <th>Ref</th>
      <th>Date</th>
      <th>Montant</th>
      <th>Status</th>
    </tr>
    <tr v-for="sale of sales" :key="sale.id">
      <td>
        <router-link :to="{ path: '/v3/admin/verif', query: { ref: sale.ref } }"
          >{{ sale.ref }} ({{ sale.occurence }})
        </router-link>
      </td>
      <td>{{ idyuFormatDate(sale.date) }}</td>
      <td>{{ idyuFormatPrice(sale.price, "EUR") }}</td>
      <td><span v-html="idyuSalesStatus(sale.status)"></span> ({{ sale.status }})</td>
    </tr>
  </table>
</template>

<script>
import { idyuFormatDate } from "../../assets/js/idyu/util";
import { idyuSalesStatus } from "@/assets/js/idyu/reference";
import { idyuFormatPrice } from "@/assets/js/idyu/util.js";

export default {
  props: ["sales"],
  methods: {
    idyuFormatPrice: idyuFormatPrice,
    idyuSalesStatus: idyuSalesStatus,
    idyuFormatDate: idyuFormatDate
  }
};
</script>

<style scoped>
.paiements {
  margin-top: 10px;
}

a {
  color: blue;
  text-decoration: underline;
}
</style>
